const TOKEN_KEY = "token";
const ADMIN_TOKEN_KEY = "admintoken";
const ADMIN_LANG_KEY = "adminlang";
const MISC_KEY = "misc";
const LANG_KEY = "lang";
const LEARNING_CATTITLE_KEY = "learningcategory";
const CATID_KEY = "categoryid";
const BRIGHTCOVE_ACCOUNT_ID = "brightcoveaccountid";
const TOTAL_QUESTIONS = "assignmentquestions";
const PASS_PERCENT = "passpercentage";
const ROLE = "role";
const NAME = "name";

export function setTotalQuestions(value) {
  localStorage.setItem(TOTAL_QUESTIONS, value);
}
export function getTotalQuestions() {
  return localStorage.getItem(TOTAL_QUESTIONS);
}

export function setPassPercent(value) {
  localStorage.setItem(PASS_PERCENT, value);
}
export function getPassPercent() {
  return localStorage.getItem(PASS_PERCENT);
}
export function setBrightcoveAccountId(value) {
  localStorage.setItem(BRIGHTCOVE_ACCOUNT_ID, value);
}
export function getBrightcoveAccountId() {
  return localStorage.getItem(BRIGHTCOVE_ACCOUNT_ID);
}
export function setRole(value) {
  localStorage.setItem(ROLE, value);
}
export function getRole() {
  return localStorage.getItem(ROLE);
}
export function setName(value) {
  localStorage.setItem(NAME, value);
}
export function getName() {
  return localStorage.getItem(NAME);
}
export function setToken(value) {
  sessionStorage.setItem(TOKEN_KEY, value);
}
export function setAdminToken(value) {
  sessionStorage.setItem(ADMIN_TOKEN_KEY, value);
}
export function getlocalToken() {
  return sessionStorage.getItem(TOKEN_KEY);
}
export function getlocalAdminToken() {
  return sessionStorage.getItem(ADMIN_TOKEN_KEY);
}
export function setLang(value) {
  localStorage.setItem(LANG_KEY, value);
}
export function getLang() {
  const lang = localStorage.getItem(LANG_KEY);
  return lang === null || lang === undefined ? "en-US" : lang;
}
export function getAdminLang() {
  const lang = localStorage.getItem(ADMIN_LANG_KEY);
  return lang === null || lang === undefined ? "en-US" : lang;
}
export function setAdminLang(value) {
  localStorage.setItem(ADMIN_LANG_KEY, value);
}
export function setMisc(obj) {
  localStorage.setItem(MISC_KEY, obj);
}
export function getMisc(key) {
  const obj = JSON.parse(localStorage.getItem(MISC_KEY));
  const filteredObj = obj.filter((d) => d.Key === key)[0].Text;
  return filteredObj === null ? "" : filteredObj;
}

export function setLearningCategoryTitle(value) {
  localStorage.setItem(LEARNING_CATTITLE_KEY, value);
}
export function getLearningCategoryTitle() {
  return localStorage.getItem(LEARNING_CATTITLE_KEY);
}

export function setCategoryId(value) {
  localStorage.setItem(CATID_KEY, value);
}
export function getCategoryId() {
  return localStorage.getItem(CATID_KEY);
}

export function clearStorage() {
  localStorage.clear();
}



// WEBPACK FOOTER //
// ./src/localstorage-service.js